import React from 'react';

import i18n from '../../i18n';

// @mui
import {
    TextField,
} from '@mui/material';

export default class DialogBigTextField extends React.Component {
    render() {
        // field, value, cache, onChange
        let show = this.props.field.show;
        let value = this.props.value?.[show] || this.props.value;
        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        const onlyRead = !!this.props.field.onlyRead;

        return (
            <TextField
                key={this.props.field.id}
                autoFocus={this.props.autoFocus}
                id={this.props.field.id}
                label={translatedName}
                type="text"
                required={Boolean(this.props.field.required)}
                error={Boolean(this.props.error)}
                // A validation message replaces the static hint while it is
                // showing; both would not fit. Same shape as DialogSelectField.
                helperText={
                    this.props.error ||
                    (this.props.field.helperText
                        ? i18n.t(`helperTexts.${this.props.field.helperText}`)
                        : '')
                }
                // `value`, not `defaultValue`: uncontrolled meant a template or
                // any other programmatic change never reached this field.
                value={value || ''}
                disabled={onlyRead}
                fullWidth
                multiline
                minRows={3}
                maxRows={10}
                onBlur={this.props.onBlur}
                onChange={(event) => this.props.onChange(event.target.id, event.target.value)}
            />
        );
    }
}
